import * as betroyale from './PromotionsNotifications.styles.betroyale';
import * as goldenrush from './PromotionsNotifications.styles.goldenrush';
import * as juicybet from './PromotionsNotifications.styles.juicybet';
import * as puntgenie from './PromotionsNotifications.styles.puntgenie';
import * as questbet from './PromotionsNotifications.styles.questbet';
import * as vikingbet from './PromotionsNotifications.styles.vikingbet';
import * as volcanobet from './PromotionsNotifications.styles.volcanobet';
import * as puntcity from './PromotionsNotifications.styles.puntcity';
import * as junglebet from './PromotionsNotifications.styles.junglebet';
import * as fiestabet from './PromotionsNotifications.styles.fiestabet';
import * as oldgill from './PromotionsNotifications.styles.oldgill';
import * as sugarcastle from './PromotionsNotifications.styles.sugarcastle';
import * as buffalobet from './PromotionsNotifications.styles.buffalobet';
import * as titanbet from './PromotionsNotifications.styles.titanbet';
import * as slambet from './PromotionsNotifications.styles.slambet';
import * as gigabet from './PromotionsNotifications.styles.gigabet';
import * as betstride from './PromotionsNotifications.styles.betstride';
import * as templebet from './PromotionsNotifications.styles.templebet';
import * as goldenbet888 from './PromotionsNotifications.styles.goldenbet888';
import * as hyperbet from './PromotionsNotifications.styles.hyperbet';
import * as bet777 from './PromotionsNotifications.styles.bet777';
import * as chromabet from './PromotionsNotifications.styles.chromabet';
import * as bet575 from './PromotionsNotifications.styles.bet575';
import * as betblast from './PromotionsNotifications.styles.betblast';
import * as pyramidbet from './PromotionsNotifications.styles.pyramidbet';
import * as magnumbet from './PromotionsNotifications.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betroyale,
  goldenrush,
  juicybet,
  puntgenie,
  questbet,
  vikingbet,
  volcanobet,
  puntcity,
  junglebet,
  fiestabet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
